import { useContext } from "react";
import { Text } from "@chakra-ui/react";
import { WfLinkGhost } from "src/components/base/wf-link";
import { IFeedCardHeadlineBody } from "src/components/feed-card/types/content";
import { EnumFeedClickTrackingArea, useFeedClickTracking } from "src/components/pages/feed/hooks/use-feed-click-tracking";
import { useDateTimeFormatter } from "src/hooks/formatters/use-date-time-formatter";
import { FeedCardContext } from "../../feed-card";

export const FeedCardHeadline = ({ text, time, url }: IFeedCardHeadlineBody) => {
    const context = useContext(FeedCardContext);
    const { formatTimeShort } = useDateTimeFormatter();
    const { trackFeedClick } = useFeedClickTracking();
    const onHeadlineLinkClick = () => {
        trackFeedClick(context.contentId, url!, EnumFeedClickTrackingArea.Body);
    };

    return (
        <Text fontSize="md">
            {time ? `${formatTimeShort(new Date(time))} ` : null}
            {url ? (
                <WfLinkGhost target="_blank" href={url} fontWeight="semibold" onClick={onHeadlineLinkClick}>
                    {text}
                </WfLinkGhost>
            ) : (
                <Text as="span" fontSize="md" fontWeight="semibold">
                    {text}
                </Text>
            )}
        </Text>
    );
};
